import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AppSharedModule} from '../../../appShared.module';
import {AdminSidenavComponent} from '../../../shared/layout/side-navbar/admin-sidenav.component';

import {ListLayoutComponent} from './list-layout/list-layout.component';
import {StepLayoutComponent} from './step-layout/step-layout.component';
import {ComponentPaiementComponent} from './components/component-paiement/component-paiement.component';
import {ComponentInformationsComponent} from './components/component-informations/component-informations.component';
import {ComponentPropertyComponent} from './components/component-property/component-property.component';
import {ComponentOwnerComponent} from './components/component-owner/component-owner.component';

import {
  AccommodationFeaturesComponent
} from '../../../shared/components/accommodation-specific/accommodation-features/accommodation-features.component';
import {
  AccommodationItemCardComponent
} from '../../../shared/components/accommodation-specific/accommodation-item-card/accommodation-item-card.component';
import {
  AccommodationModalDetailsComponent
} from '../../../shared/components/accommodation-specific/accommodation-modal-details/accommodation-modal-details.component';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {LocalSettingsService} from '../../../services/local-settings.service';
import {TranslateService} from '@ngx-translate/core';
import {
  AccommodationPriceBoxComponent
} from '../../../shared/components/accommodation-specific/accommodation-price-box/accommodation-price-box.component';

import {AccomRoomspecComponent} from '../../../shared/components/accommodation-specific/accom-roomspec/accom-roomspec.component';
import {ComponentFilterModalComponent} from './components/component-filter-modal/component-filter-modal.component';
import {
  AccommodationBookingDocumentsComponent
} from '../../../shared/components/accommodation-specific/accommodation-booking-documents/accommodation-booking-documents.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {
  AccommodationPhotoComponent
} from '../../../shared/components/accommodation-specific/accommodation-photo/accommodation-photo.component';
import {
  AccommodationReservationProcessComponent
} from '../../../shared/components/accommodation-specific/accommodation-reservation-process/accommodation-reservation-process.component';
import {
  AccommodationCancelPoliticComponent
} from '../../../shared/components/accommodation-specific/accommodation-cancel-politic/accommodation-cancel-politic.component';
import {
  AccommodationRoomCardComponent
} from '../../../shared/components/accommodation-specific/accommodation-room-card/accommodation-room-card.component';
import {AccommodationMapCardComponent} from './components/accommodation-map-card/accommodation-map-card.component';
import {AccommodationMapComponent} from '../../../shared/components/accommodation-specific/accommodation-map/accommodation-map.component';
import {PropertyLayoutComponent} from './property-layout/property-layout.component';
import {ComponentBookingInfoComponent} from './components/component-booking-info/component-booking-info.component';
import {AccommodationPaymentDetailsComponent} from './components/accommodation-payment-details/accommodation-payment-details.component';
import {ComponentPendingComponent} from './components/component-pending/component-pending.component';
import {ArticleCardComponent} from '../../../shared/components/article-card/article-card.component';
import {CtaCardComponent} from '../../../shared/components/cta-card/cta-card.component';
import {
  AccommodationSliderRoomCardComponent
} from '../../../shared/components/accommodation-specific/accommodation-slider-room-card/accommodation-slider-room-card.component';
import {AccommodationAlertsComponent} from './components/accommodation-alerts/accommodation-alerts.component';
import {MatRadioModule} from '@angular/material/radio';
import {AccommodationCityInputComponent} from './components/accommodation-city-input/accommodation-city-input.component';
import {FilterContentComponent} from './components/component-filter-modal/filter-content/filter-content.component';
import {ItemBadgesComponent} from '../../../shared/components/item-badges/item-badges.component';
import {AuthGuard} from '../../../helpers/auth.guard';
import {PostReservationLayoutComponent} from './post-reservation-layout/post-reservation-layout.component';

export const AccommodationRouteList: Routes = [
  {
    path: '',
    component: AdminSidenavComponent,
    children: [
      {
        path: 'list',
        component: ListLayoutComponent,
        data: {mode: 'list',pageTitle: 'PROCESSES.ACCOMMODATION.TITLE'},
        children: [
          { path: ':city', component: ListLayoutComponent, }
        ]
      },
      {
        path: 'property/:id', component: PropertyLayoutComponent,
        data: {mode: 'property'}
      },
      {
        path: ':city/property/:id', component: PropertyLayoutComponent,
        data: {mode: 'property'}
      },
      {
        path: 'informations', component: StepLayoutComponent,
        data: {page: 'informations', showNavBar: true}
      },
      {
        path: 'payment', component: StepLayoutComponent,
        data: {page: 'paiement', showNavBar: true}
      },
      {
        path: 'post-reservation', component: PostReservationLayoutComponent, canActivate: [AuthGuard],
        data: {page: 'post-reservation', showNavBar: false}

      },
      {
        path: 'pending', component: StepLayoutComponent, canActivate: [AuthGuard],
        data: {page: 'pending', showNavBar: true}
      },
      {
        path: 'rejected', component: StepLayoutComponent, canActivate: [AuthGuard],
        data: {page: 'rejected', showNavBar: false}
      },
      {
        path: 'validated', component: StepLayoutComponent, canActivate: [AuthGuard],
        data: {page: 'validated', showNavBar: false}
      },
      {
        path: 'call-an-agent', component: StepLayoutComponent, canActivate: [AuthGuard],
        data: {page: 'call-an-agent', showNavBar: false}
      },
      {
        path: 'refunded', component: StepLayoutComponent, canActivate: [AuthGuard],
        data: {page: 'refunded', showNavBar: false}
      },
      { path: '**', redirectTo: 'list', pathMatch: 'full' }

    ],
    data: {
      margin:false
    }
  }
]


@NgModule({
    imports: [
        RouterModule.forChild(AccommodationRouteList),
        AppSharedModule,
        NgxSliderModule,
        MatCheckboxModule,
        MatRadioModule,
        ItemBadgesComponent,
        ListLayoutComponent,
        StepLayoutComponent,
        ComponentPaiementComponent,
        ComponentInformationsComponent,
        ComponentPropertyComponent,
        AccommodationFeaturesComponent,
        AccommodationItemCardComponent,
        AccommodationModalDetailsComponent,
        AccommodationPriceBoxComponent,
        AccomRoomspecComponent,
        ComponentFilterModalComponent,
        AccommodationBookingDocumentsComponent,
        ComponentOwnerComponent,
        AccommodationPhotoComponent,
        AccommodationReservationProcessComponent,
        AccommodationCancelPoliticComponent,
        AccommodationRoomCardComponent,
        AccommodationMapCardComponent,
        AccommodationMapComponent,
        PropertyLayoutComponent,
        ArticleCardComponent,
        ComponentBookingInfoComponent,
        AccommodationPaymentDetailsComponent,
        CtaCardComponent,
        ComponentPendingComponent,
        AccommodationSliderRoomCardComponent,
        AccommodationAlertsComponent,
        AccommodationCityInputComponent,
        FilterContentComponent,
    ],
    exports: [
        // MODULES --------
        NgxSliderModule,
        // COMPOSANTS --------
        ListLayoutComponent,
        StepLayoutComponent,
        ComponentPaiementComponent,
        ComponentInformationsComponent,
        ComponentPropertyComponent,
        AccommodationFeaturesComponent,
        AccommodationItemCardComponent,
        AccommodationModalDetailsComponent,
        AccommodationPhotoComponent,
        ArticleCardComponent,
        AccommodationRoomCardComponent,
        CtaCardComponent,
        AccommodationSliderRoomCardComponent,
        AccommodationAlertsComponent,
    ],
})

export class AccommodationModule {

  constructor(
    private _localSettings: LocalSettingsService,
    public translate: TranslateService,
  ) {
    const userLang: string = this._localSettings.getLanguage()
      ? this._localSettings.getLanguage()
      : 'en';
    this.translate.use(userLang);
  }
}
